export function verifyOutput(output, reporter) {
  reportErrorThrown(output, reporter);
  reportInvalidActions(output, reporter);
}
function reportErrorThrown(output, reporter) {
  if (output.notification.kind === 'E') {
    reporter.handleError(output.notification.error);
  }
}
function reportInvalidActions(output, reporter) {
  if (output.notification.kind === 'N') {
    const action = output.notification.value;
    const isInvalidAction = !isAction(action);
    if (isInvalidAction) {
      reporter.handleError(
        new Error('Effect ' + getEffectName(output) + ' dispatched an invalid action: ' + stringify(action)),
      );
    }
  }
}
function isAction(action) {
  return action && action.type && typeof action.type === 'string';
}
function getEffectName(_a) {
  const propertyName = _a.propertyName,
    sourceInstance = _a.sourceInstance,
    sourceName = _a.sourceName;
  const isMethod = typeof sourceInstance[propertyName] === 'function';
  return '"' + sourceName + '.' + propertyName + (isMethod ? '()' : '') + '"';
}
function stringify(action) {
  try {
    return JSON.stringify(action);
  } catch (_a) {
    return action;
  }
}
